<template>
  <span
    class="is-clickable"
    v-on:click="copy"
    title="Copy this IID to your clipboard"
  >
    <i
      class="icon-teklia-e mr-1"
      v-if="isTeklia"
    ></i>
    <samp class="is-size-6">{{ dockerImageIID }}</samp>
    <i class="icon-clipboard"></i>
  </span>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import { truncateMixin } from '@/mixins'
import { useNotificationStore } from '@/stores'

export default defineComponent({
  props: {
    iid: {
      type: String,
      required: true,
    },
  },
  mixins: [truncateMixin],
  data: () => ({
    /**
     * Whether the Docker image IID should be truncated or displayed fully.
     * It should be fully displayed when the user clicks on the IID.
     */
    truncated: true,
  }),
  computed: {
    isTeklia() {
      if (!this.iid) return
      return this.iid.startsWith('registry.gitlab.teklia.com/')
    },
    dockerImageIID() {
      if (!this.iid) return '—'
      let display = this.iid
      if (this.isTeklia) display = this.iid.replace('registry.gitlab.teklia.com/', '')
      if (this.truncated) return this.truncateShort(display)
      return display
    },
  },
  methods: {
    ...mapActions(useNotificationStore, ['notify']),
    async copy() {
      if (!this.iid) return
      this.truncated = false
      try {
        await navigator.clipboard.writeText(this.iid)
        this.notify({ type: 'success', text: 'Docker image IID copied to clipboard' })
      } catch (err) {
        this.notify({ type: 'error', text: `Failed to copy IID '${this.iid}': ${err}` })
      }
    },
  },
  watch: {
    /**
     * A change in the IID without re-mounting the component probably means
     * this component was reused by Vue or the router, so we reset the
     * truncated state as if we had just mounted the component.
     */
    iid() {
      this.truncated = true
    },
  },
})
</script>
